import { createBrowserHistory, createMemoryHistory } from 'history';

const history = typeof window === 'undefined'
    ? createMemoryHistory({
      initialEntries: ['/']
    })
    : createBrowserHistory();

export default history;